import { useEffect } from 'react';
import { getPetTypeFromText } from 'utils/pet-type/get-pet-type-from-text';
import { useRouter } from 'next/router';
import { useRootStore } from 'stores/use-root-store';
import { useRegion } from 'hooks/use-region';

/** Listens to route change events and syncs pet type. */
export const useSyncPetTypeFromRoute = (): void => {
  const { isReady, asPath } = useRouter();
  const region = useRegion();
  const setPetType = useRootStore((store) => store.setPetType);

  useEffect(() => {
    if (!isReady) return;
    const ignore = ['/futterberater'];

    if (ignore.includes(asPath)) return;

    const petType = getPetTypeFromText({ text: asPath, region });
    if (!petType) return;
    setPetType(petType);
  }, [asPath, isReady, region, setPetType]);
};
